import React from "react";

// Panel shown when a study hasn't been migrated to canonical storage (#258).
// Matches the labeling-viewer treatment in ProjectCaseList (#305) so users
// get a consistent explanation instead of an indefinite "Loading Images"
// spinner.
export const StudyNotCanonicalizedPanel: React.FC = () => (
  <div className="w-full h-full flex flex-col items-center justify-center bg-bg-2 px-6 text-center">
    <div className="rounded-full border border-border-strong bg-surface-2 px-3 py-1 text-xs text-fg-muted mb-4">
      Migration pending
    </div>
    <p className="text-sm text-fg mb-2 max-w-md">
      This study hasn't been migrated to canonical storage yet.
    </p>
    <p className="text-xs text-fg-muted max-w-md">
      Images can't be loaded until canonicalization completes. The case list, findings, and
      predictions remain available.
    </p>
  </div>
);
